import { Either, fromNullable, left, tryCatch2v } from 'fp-ts/lib/Either';
import storageAvailable from './storageAvailable';

const sessionStorageAvailable = storageAvailable('sessionStorage');

export function getJSON(key: string): Either<unknown, unknown> {
  return sessionStorageAvailable
    ? fromNullable('Session Storage .getItem failed')(
        window.sessionStorage.getItem(key)
      ).chain(rawData =>
        tryCatch2v(() => JSON.parse(rawData), () => 'JSON.parse failed')
      )
    : left('Session storage not available');
}

export function setJSON(key: string, value: unknown): void {
  if (sessionStorageAvailable) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch {}
  }
}
